import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Grid2 as Grid, IconButton, Tooltip } from '@mui/material';
import { BoxedTypography } from './BoxedUrlWithCopy.styles';

const BoxedUrlWithCopy = ({ url }: { url: string }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setTooltipOpen(false);
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid>
        <BoxedTypography variant="body1">{url}</BoxedTypography>
      </Grid>
      <Grid>
        <Tooltip title="Copied to clipboard!" open={tooltipOpen} onClose={() => setTooltipOpen(false)} placement="top">
          <IconButton onClick={handleCopy} onMouseLeave={handleMouseLeave}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default BoxedUrlWithCopy;
